import React from "react";
import { HOCType } from "../constants/types";
import { PopupProvider } from "../contexts/PopupContext";

export const withPopupProvider: HOCType = (WrappedComponent) => (props) => (
  <PopupProvider>
    <WrappedComponent {...props} />
  </PopupProvider>
);
